import { ImageCustom } from "../Image/index";
import { useState, useEffect } from "react";

import {
  Pillars,
  PillarsWrapper,
  PillarsBox,
  PillarsCards,
  TitlePillar,
  SubTitlePillar,
  PillarsImgs,
  TextImgs,
  PillarsBackgroud,
  PillarsArrowTop,
  PillarsArrowBottom,
  IconsCards,
} from "./style";

import TitleComponent from "../SectionTitle";
import PillarsCarousel from "../PillarsCarousel";
import { listUrl } from "../Data";
const titletex = "Conheça os";
const subtitletex = "Nossos pilares";

const PillarsComponent = () => {
  const [mobile, setMobile] = useState(false);

  const isMobile = () => {
    const { innerWidth } = window;

    setMobile(innerWidth <= 768);
  };

  useEffect(() => {
    isMobile();
  }, []);

  const images = listUrl.pillars.images;

  return (
    <Pillars>
      <PillarsArrowTop>
        <ImageCustom
          src={mobile ? images.arrowmobile : images.arrowdesk}
          alt=""
        />
      </PillarsArrowTop>
      <PillarsBackgroud id="Pilares">
        <ImageCustom
          src={mobile ? images.bannermobile : images.bannerdesk}
          alt=""
        />
      </PillarsBackgroud>
      <PillarsWrapper>
        <TitleComponent TitleText={titletex} SubTitleText={subtitletex} />
        <PillarsBox>
          <PillarsCards>
            <PillarsImgs>
              <IconsCards>
                <ImageCustom src={images.production} alt="" />
              </IconsCards>
            </PillarsImgs>
            <TitlePillar>Produção Responsável</TitlePillar>
            <SubTitlePillar>
              Gerar valor para a sociedade a partir do desenvolvimento de uma
              cadeia ética, responsável, segura e sustentável.
            </SubTitlePillar>
          </PillarsCards>
          <PillarsCards>
            <PillarsImgs>
              <IconsCards>
                <ImageCustom src={images.environmentHealthy} alt="" />
              </IconsCards>
            </PillarsImgs>
            <TitlePillar>Meio Ambiente Saudável</TitlePillar>
            <SubTitlePillar>
              Desenvolver produtos considerando todo o seu ciclo de vida, sempre
              priorizando alternativas de menor impacto.
            </SubTitlePillar>
          </PillarsCards>
          <PillarsCards>
            <PillarsImgs>
              <IconsCards>
                <ImageCustom src={images.empoweredPeople} alt="" />
              </IconsCards>
            </PillarsImgs>
            <TitlePillar>Pessoas Empoderadas</TitlePillar>
            <SubTitlePillar>
              Garantir um ambiente inclusivo, seguro e próspero para todos.
            </SubTitlePillar>
          </PillarsCards>
          <PillarsCards>
            <PillarsImgs>
              <IconsCards>
                <ImageCustom src={images.communication} alt="" />
              </IconsCards>
            </PillarsImgs>
            <TitlePillar>Comunicação transparente</TitlePillar>
            <SubTitlePillar>
              Comunicar com responsabilidade e promover a educomunicação para
              todos os públicos.
            </SubTitlePillar>
          </PillarsCards>
        </PillarsBox>
        <PillarsCarousel />
      </PillarsWrapper>
    </Pillars>
  );
};

export default PillarsComponent;
